var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m135.5 90.25h60.25c8.284 0 15-6.716 15-15s-6.716-15-15-15h-60.25c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.5 150.5h60.25c8.284 0 15-6.716 15-15s-6.716-15-15-15h-60.25c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.5 210.75h60.25c8.284 0 15-6.716 15-15s-6.716-15-15-15h-60.25c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.5 271h60.25c8.284 0 15-6.716 15-15s-6.716-15-15-15h-60.25c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.5 331.25h60.25c8.284 0 15-6.716 15-15s-6.716-15-15-15h-60.25c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.5 391.5h60.25c8.284 0 15-6.716 15-15s-6.716-15-15-15h-60.25c-8.284 0-15 6.716-15 15s6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.75 180.75h-15.125v-45.25c0-8.284-6.716-15-15-15s-15 6.716-15 15v45.25h-60.375v-105.5c0-8.284-6.716-15-15-15s-15 6.716-15 15v105.5h-30.25v-165.75c0-8.284-6.716-15-15-15h-180.75c-8.284 0-15 6.716-15 15v482c0 8.284 6.716 15 15 15h361.5c8.284 0 15-6.716 15-15v-301.25c0-8.284-6.716-15-15-15zm-256 301.25h-30.25v-30.25h30.25zm60.25 0h-30.25v-45.25c0-8.284-6.716-15-15-15h-60.25c-8.284 0-15 6.716-15 15v45.25h-30.25v-452h150.75zm120.5 0h-30.25v-30.25h30.25zm60.25 0h-30.25v-45.25c0-8.284-6.716-15-15-15h-60.25c-8.284 0-15 6.716-15 15v45.25h-30.25v-271.25h150.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.25 271c7.846 0 15.363-6.899 15-15-.364-8.127-6.591-15-15-15-7.846 0-15.363 6.899-15 15 .364 8.127 6.591 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.5 271c7.846 0 15.363-6.899 15-15-.364-8.127-6.591-15-15-15-7.846 0-15.363 6.899-15 15 .364 8.127 6.591 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.25 331.25c7.846 0 15.363-6.899 15-15-.364-8.127-6.591-15-15-15-7.846 0-15.363 6.899-15 15 .364 8.127 6.591 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.5 331.25c7.846 0 15.363-6.899 15-15-.364-8.127-6.591-15-15-15-7.846 0-15.363 6.899-15 15 .364 8.127 6.591 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.25 391.5c7.846 0 15.363-6.899 15-15-.364-8.127-6.591-15-15-15-7.846 0-15.363 6.899-15 15 .364 8.127 6.591 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.5 391.5c7.846 0 15.363-6.899 15-15-.364-8.127-6.591-15-15-15-7.846 0-15.363 6.899-15 15 .364 8.127 6.591 15 15 15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeBuilding);
export default __webpack_public_path__ + "static/media/office-building.bd92a3bf90fb0c50387ff7424130d324.svg";
export { ForwardRef as ReactComponent };